import React from 'react'
import { Link } from 'react-router-dom'
import { useLanguage } from '../context/LanguageContext';
import { Typography } from '@mui/material';
import logo from '../Image/logo.png';

const Desktopfooter = () => {
  const { t } = useLanguage();

  return (
<div className='desktop-footer'>
<div className='desktop-subfooter'>
<Typography variant='h5'>Copyright © 2026 www.orocancerwatch.in All rights reserved.</Typography>
</div>
</div>
  )
}

export default Desktopfooter
